import * as actionTypes from "./actionTypes";
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import LogsHelper from 'Flow2/components/Article/Helpers/LogsHelper';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as hf from 'Flow2/util/helperFunctions.js';

export const updateArticleObjects = (data) => {
    return {
        type: actionTypes.UPDATE_ARTICLE_OBJECTS,
        payload: data
    }
}

export const showErrorDlg = ({ dispatch, formatMessage, resMsg = null, cb = null }) => {
    let msg = resMsg ? resMsg : formatMessage({ id: `customdata.somethingWrongMsg` });
    dispatch({ type: actionTypes.ARTICLES_EDIT_REPORT_FAIL });
    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => {
        if (cb) cb();
    });
}

export const updateArticleMetadata = (params) => {
    return (dispatch, getState) => {
        const { id, metadata, logsLoading, autoSave } = params;
        let viewState = getState().ui.leftSidebarState;
        if (params && id && metadata) {
            if (!autoSave) dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
            let updateMetaFc = autoSave ? "vifograSaveArticle" : "editDistproject";
            window.flow[updateMetaFc](id, metadata).then((res) => {
                if (autoSave && viewState === ArticleTypes.CLOSED) {
                    console.log("LAMTEST AUTOSAVE res", updateMetaFc, res);
                }
                else {
                    console.log("LAMTEST updateArticleMetadata res ", updateMetaFc, res);
                    dispatch(actions.updateMetadataArticleSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    dispatch(actions.getArticleByDist());
                    if (logsLoading) {
                        dispatch(actions.updateArticleObjects({ logsLoading }));
                        setTimeout(() => dispatch(actions.updateArticleObjects({ logsLoading: false })), 1000)
                    } else {
                        if (getState().article.articleObjects.articleTabMetaLoading) {
                            dispatch(actions.updateArticleObjects({ articleTabMetaLoading: false }))
                        }
                    }
                }
            }).catch((err) => {
                dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            });

        }
    }
}

export const handleArticlesRes = ({ res, dispatch, getState }) => {
    if (res) {
        if (res.objects) {
            const articles = res.objects.asArray();
            dispatch({ type: actionTypes.ARTICLES_SEARCH_SUCCESS, searchArticles: articles });
        }
        if (res.distproject && res.distproject.elements) {
            dispatch({ type: actionTypes.ARTICLES_GET_SUCCESS, articles: res.distproject.elements });
        }

        if (res.count) {
            const { articlePagination } = getState().article.articleObjects;
            let newTotalPages = Math.ceil(res.count / res.limit);
            if (articlePagination.totalPages != newTotalPages) {
                dispatch(actions.updateArticleObjects({ articlePagination: { ...articlePagination, totalPages: newTotalPages } }));
            }
        }
    }
}

export const getArticlesByDist = ({ dispatch, getState, fields = [], isSearch = false }) => {
    dispatch({ type: actionTypes.ARTICLES_GET_START });
    fields.push({ field: 'publishdate', type: 'order', value: 'desc' });
    let limit = getState().article.articleObjects.articlePagination.limit;
    let offset = (getState().article.articleObjects.articlePagination.currentPage - 1) * limit;
    if (isSearch) offset = 0;
    dispatch(actions.updateArticleObjects({ articleItemsLoading: true }));
    window.flow
        .getDistprojectsForDist('pmdb_newstv', 0, fields, { limit, offset })
        .then(res => {
            handleArticlesRes({ res, dispatch, getState });
            dispatch(actions.updateArticleObjects({ articleItemsLoading: false }));
        })
        .catch(err => {
            dispatch({ type: actionTypes.ARTICLES_GET_FAIL });
            dispatch(actions.applicationError(err.message));
            dispatch(actions.updateArticleObjects({ articleItemsLoading: false }));
        });
}

export const getArticles = () => {
    return (dispatch, getState) => getArticlesByDist({ dispatch, getState })
};

export const searchAndSortArticlesByFields = (fields, isSearch = false) => {
    if (fields && fields.length) fields = fields.filter(item => item);
    return (dispatch, getState) => getArticlesByDist({ dispatch, getState, fields, isSearch });
}

export const searchReport = ({ articleid, sortcrit = "dldate", sortorder = "desc" }) => {
    return (dispatch, getState) => {
        window.flow.vifogradlreportSearch({ articleid, sortcrit, sortorder })
            .then(res => {
                if (res && res.data && res.data.length) {
                    let articleReports = {
                        ...getState().article.articleObjects.articleReports,
                        currentData: res.data, currentId: articleid
                    }
                    dispatch(actions.updateArticleObjects({ articleReports }))
                }
            })
    }
}

export const searchAllReports = () => {
    return (dispatch, getState) => {
        window.flow.vifogradlreportSearch()
            .then(res => {
                if (res && res.data && res.data.length) {
                    //res.data[0].filename = Date.now().toString();
                    let totalItems = res.data.length;
                    const { articleAllReports } = getState().article.articleObjects;
                    let itemsPerPage = articleAllReports.itemsPerPage || ArticleTypes.ITEMS_PER_PAGE;
                    let reportsObj = {
                        currentPage: 1,
                        ...articleAllReports,
                        currentData: res.data,
                        totalItems,
                        totalPages: Math.ceil(totalItems / itemsPerPage),
                    }
                    dispatch(actions.updateArticleObjects({ articleAllReports: reportsObj }))
                }
            })
            .catch(err => console.log("LAMTEST err", err));
    }
}

export const publishArticle = ({ obj, formatMessage }) => {
    return (dispatch) => {
        const { articleid, recipients } = obj;
        if (obj && articleid && recipients) {
            dispatch({ type: actionTypes.ARTICLES_PUBLISH_ARTICLE_START });
            const { logs, articleId } = LogsHelper.getLogsObj({ action: ArticleTypes.PUBLISHED, id: articleid });
            if (logs && articleId) dispatch(actions.updateArticleMetadata({ id: articleId, metadata: { logs }, logsLoading: true }));
            dispatch(actions.updateArticleObjects({ articleLoading: true }));
            let loadInt = setInterval(() => dispatch({ type: actionTypes.METADATA_LOADING, loading: true }), 100);
            setTimeout(() => {
                console.log("LAMTEST publishArticle obj", obj);
                window.flow.vifograpublish({ ...obj }).then(res => {
                    if (res) {
                        console.log("LAMTEST publishArticle res", res);
                        if (res.msg) showErrorDlg({
                            dispatch, formatMessage, resMsg: res.msg, cb: () => {
                                dispatch(actions.updateArticleMetadata({ id: articleId, metadata: {} }));
                                dispatch({ type: actionTypes.ARTICLES_PUBLISH_ARTICLE_SUCCESS });
                                dispatch(actions.updateArticleObjects({ articleLoading: false }));
                                dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                                clearInterval(loadInt);
                            }
                        });
                        else if (res && !res.success) showErrorDlg({
                            dispatch, formatMessage, cb: () => {
                                dispatch({ type: actionTypes.ARTICLES_PUBLISH_ARTICLE_SUCCESS });
                                dispatch(actions.updateArticleObjects({ articleLoading: false }));
                                dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                                clearInterval(loadInt);
                            }
                        });
                    }
                }).catch(err => {
                    showErrorDlg({
                        dispatch, formatMessage, resMsg: err ? `<p>${err}</p>` : null, cb: () => {
                            console.log("LAMTEST ERR CB");
                            dispatch({ type: actionTypes.ARTICLES_PUBLISH_ARTICLE_FAIL });
                            dispatch(actions.updateArticleObjects({ articleLoading: false }));
                            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                            clearInterval(loadInt);
                        }
                    });
                });
            }, 1000);
        }
    }
}

export const editReport = ({ articleid, data, formatMessage, showAll = false }) => {
    if (articleid && data && data.length)
        return dispatch => {
            dispatch({ type: actionTypes.ARTICLES_EDIT_REPORT_START });
            setTimeout(() => {
                let max = data.length;
                data.forEach(item => {
                    window.flow.vifogradlreportEdit(item)
                        .then(res => {
                            if (res && res.success) {
                                if (showAll) dispatch(actions.searchAllReports());
                                else dispatch(actions.searchReport({ articleid }));
                                max--;
                                if (!max) dispatch({ type: actionTypes.ARTICLES_EDIT_REPORT_SUCCESS });
                            } else showErrorDlg({ dispatch, formatMessage });
                        })
                        .catch(err => showErrorDlg({ dispatch, formatMessage }))
                })
            }, 1000);
        }
}

export const deleteArticle = (id) => {
    return (dispatch => {
        dispatch({ type: actionTypes.ARTICLES_DELETE_START });
        window.flow.delDistproject(id).then(res => {
            dispatch({ type: actionTypes.ARTICLES_DELETE_SUCCESS });
            dispatch(getArticles());
        }).catch(err => {
            dispatch({ type: actionTypes.ARTICLES_DELETE_FAIL });
            dispatch(actions.applicationError(err.message));
        });
    })
}

export const saveNewArticle = (title, metadata = { publishdate: "2099-01-01", customid: "A" + hf.getRandomString(11), ...metadata }) => {
    return ((dispatch, getState) => {
        dispatch({ type: actionTypes.ARTICLES_SAVE_NEW_START });
        let logs = LogsHelper.updateLogsData({
            action: ArticleTypes.CREATE,
            user: getState().auth.user.id, isFirst: true
        });

        window.flow.newDistproject("pmdb_newstv", 0, { 'title': title, 'logs': logs, ...metadata }).then(res => {
            dispatch({ type: actionTypes.ARTICLES_SAVE_NEW_SUCCESS });
            dispatch(getArticles());
            dispatch(actions.getDistributionByDist());
        }).catch(err => {
            dispatch({ type: actionTypes.ARTICLES_SAVE_NEW_FAIL });
            dispatch(actions.applicationError(err.message));
        });
    })
}

export const removeClipsFromArticle = (id, clipIds) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.ARTICLES_REMOVE_CLIPS_START });
        window.flow.distprojectRemoveClipById(id, clipIds).then(res => {
            dispatch({ type: actionTypes.ARTICLES_REMOVE_CLIPS_SUCCESS });
            dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_DISTRIBUTION, id));
        }).catch(err => {
            dispatch({ type: actionTypes.ARTICLES_REMOVE_CLIPS_FAIL });
            dispatch(actions.applicationError(err.message));
        });
    });
}

export const setCurrentArticle = id => {
    return {
        type: actionTypes.ARTICLES_SET_CURRENT,
        id: id
    };
};

export const setActiveArticle = id => {
    return {
        type: actionTypes.ARTICLES_SET_ACTIVE,
        id: id
    };
};

export const saveArticleSortedClips = (articleId) => {
    return (dispatch, getState) => {
        let currentObj = getState().article.articleObjects.currentArticle;
        let logs = LogsHelper.updateLogsData({
            action: ArticleTypes.SAVE_SORTING, user: getState().auth.user.id,
            isFirst: false
        });
        if (currentObj && currentObj.currentId == articleId) {
            let sortedClips = currentObj.currentClips.map(item => item.id);
            if (articleId) {
                window.flow.distprojectOrder(articleId, sortedClips).then((res) => {
                    dispatch(actions.updateMetadata("article", articleId, { logs }));
                }).catch((res) => {
                    console.log(res);
                    dispatch(actions.applicationError(res.message));
                });
            }
        }
    }
}

export const stitchVideos = (clipIds, formatMessage) => {
    if (clipIds && clipIds.length) {
        let contentlink = clipIds.join(', ');
        return (dispatch) => {
            window.flow.processCreate('customprocess', 'StichVideos',
                { 'parameters': { "profile": "videostitch", "contentlink": contentlink, "contenttype": "idlist" } })
                .then(res => {
                    let params = [{ msg: "stitchVideosMsg", value: `${contentlink}` }, { msg: "stitchSuccessMsg", value: "" }]
                    let msg = DataUtil.translateArrayIntlMsgForApp(params, formatMessage);
                    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
                })
                .catch(err => {
                    console.log(err);
                    dispatch(actions.applicationError(err.message));
                });
        }
    }
}



